/** @jsxImportSource @emotion/react */

import { HPMarqueeIcon } from "assets/desktop/images/homepage";
import _map from "lodash/map";
import Marquee from "react-fast-marquee";
import { useSelector } from "react-redux";
import { selectAllAnnouncement } from "store/announcement";

import { NotiMarqueStyle } from "./index.style";

export const NotiMarque = () => {
  const announcementData = useSelector(selectAllAnnouncement);

  return (
    <section>
      <div css={NotiMarqueStyle.item}>
        <img loading="lazy" src={HPMarqueeIcon} alt="error" />
        <div css={NotiMarqueStyle.text}>
          <Marquee pauseOnHover>
            {_map(announcementData, (item) => (
              <div
                css={NotiMarqueStyle.marqueeItem}
                key={item.id}
                dangerouslySetInnerHTML={{
                  __html: `💥 ${item.title}`,
                }}
              />
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
};
